<div class="columns">
    <div class="column is-two-fifths">
        <div class="inner-content">
             <p style="color:#0E0066;font-weight: 600; font-size: 44px;">Hello!</p>
             <p  style="color:#0E0066; font-weight: 600;font-size: 20px;"> Nice to meet you.</p>
              <p style="margin-top:20px;" >Do you any questions? Ideas? </p>
              <p >Thoughts? </p> 
               <p> Do you want to be a part of the </p>
                <p> movement? Want to collaborate?</p>
                <p style="margin-top:20px; ">Or drop a message on</p>
                <a  href="#">
                    <img class="socialshare" src="../../../assets/img/whatsapp 1.png"> 
                </a>
                <a  href="#">
                    <img class="socialshare" src="../../../assets/img/facebook 1.png"> 
                </a>
            </div> 
    </div> 
    <div class="column is-two-fifths">
        <div class="inner-content">
        <div class="card">
            <div class="has-text-centered" style=" padding: 40px;">
            <form action="">
         <div class="control ">
            <input class="input " type="text" placeholder="Name">
         </div>
       <div class="control">
         <input class="input " type="text" placeholder="Email ID">
         </div>
        <div class="control">
           <textarea class="textarea has-fixed-size" placeholder="Your question/message"></textarea>
         </div>
         <div class="control">
           <button class="button is-danger is-rounded button ">Submit</button>
            </div>
        </form>
        </div>
    </div>
</div>
</div>

</div>

